import { RepositoryFactory } from "@/Apicall/masters/RepositoryFactory";
const adminPages = RepositoryFactory.get("adminPages");
import store from "../store";
export default {
  GET({ commit }) {
    return new Promise(async (resolve, reject) => {
      try {
        // const sta = state;
        console.log(store, "STATE");
        let payload = {
          projectId: store.state.user.selectedProject._id,
          projectName: store.state.user.selectedProject.projectName,
          type: "Admin",
          show: true,
        };
        const { data } = await adminPages.get(payload);
        const pages = data.data.map((x) => {
          return {
            title: x.page,
            image: `${x.icon}`,
            route: x.hasOwnProperty("path") ? x.path : "",
            headingName: x.hasOwnProperty("headingName") ? x.headingName : "",
          };
        });
        commit("SET_CUSTOM_PAGES", pages);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
};
